// Función para obtener datos del localStorage
export const getStorage = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    console.error('Error al obtener datos del localStorage:', error);
    return defaultValue;
  }
};

// Función para guardar datos en el localStorage
export const setStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    console.error('Error al guardar datos en el localStorage:', error);
    return false;
  }
};

// Función para eliminar datos del localStorage
export const removeStorage = (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.error('Error al eliminar datos del localStorage:', error);
    return false;
  }
};

// Función para crear un objeto de almacenamiento para una entidad específica
export const createStorage = (entityName) => {
  return {
    getAll: () => getStorage(entityName, []),
    getById: (id) => {
      const items = getStorage(entityName, []);
      return items.find(item => item.id === id) || null;
    },
    save: (item) => {
      const items = getStorage(entityName, []);
      const index = items.findIndex(i => i.id === item.id);
      
      if (index >= 0) {
        // Actualizar item existente
        items[index] = { ...items[index], ...item };
      } else {
        // Añadir nuevo item
        items.push(item);
      }
      
      return setStorage(entityName, items);
    },
    remove: (id) => {
      const items = getStorage(entityName, []);
      const newItems = items.filter(item => item.id !== id);
      return setStorage(entityName, newItems);
    },
    clear: () => removeStorage(entityName)
  };
};

// Función para descargar un archivo (movida aquí desde helpers.js)
export const downloadFile = (content, filename, type) => {
  const blob = new Blob([content], { type });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export default {
  getStorage,
  setStorage,
  removeStorage,
  createStorage,
  downloadFile
};